module.exports = __webpack_public_path__ + "img/gj-go.0565cfa3.png";